import Vue from 'vue'
import App from './App'
import router from './router'
import resource from 'vue-resource'
import VueCookie from 'vue-cookie'
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
import moment from 'moment'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'

UIkit.use(Icons)
Vue.config.productionTip = false
Vue.use(resource)
Vue.use(VueCookie)
Vue.use(VueLodash, lodash)

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value), 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY')
  }
})
Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value), 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
  }
})
Vue.filter('formatDatefrom', function (value) {
  if (value) {
    return moment(String(value), 'YYYY-MM-DD HH:mm:ss').lang('pl').fromNow()
  }
})
Vue.filter('truncate', function (string, value) {
  if (string.length > value) {
    return string.substring(0, value) + '...'
  }
  return string
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js